exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-cd390958] {\n  font-weight: normal;\n  margin-top: 12px !important;\n}\n.marginRadio[data-v-cd390958] {\n  margin-right: 0px;\n}\n.radio-group-full-width[data-v-cd390958] .v-input__control {\n  width: 100%;\n  padding-left: 8px;\n}\n.marginFlex[data-v-cd390958] {\n  margin-top: 15px;\n}\n.paddingTop[data-v-cd390958] {\n  padding-top: 13px;\n}\n.paddingText[data-v-cd390958] {\n  padding-top: 0;\n}\n.marginJueves[data-v-cd390958] {\n  margin-left: 13px;\n}\n.margenIzquierdo[data-v-cd390958] {\n  margin-left: 10px;\n}\n.marginDatePicker[data-v-cd390958] {\n  width: 100%;\n}\n", ""]);

// exports
